import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { UserBillingInfoDto } from '../../../meta/types/billing/billingInfo';
import { CONFIG } from '../../../meta/types/config';

const { GET, POST, DELETE, PUT } = api;

const BILLING_INFO_RESOURCE_BASE_PATH = `${CONFIG.dashboardServiceBasePath}/dashboard/v1/purchase/billinginfo`;

export interface BillingInfoResource {
  getBillingInfo: ResourceFetch<UserBillingInfoResponse, { userId: string }>;
  createBillingInfo: ResourceFetch<UserBillingInfoDto, UserBillingInfoDto>;
  deleteBillingInfo: ResourceFetch<void, { id: number }>;
  updateUserBillingInfo: ResourceFetch<UserBillingInfoDto, UserBillingInfoDto>;
}

export type UserBillingInfoResponse = {
  member: UserBillingInfoDto[];
};

const BillingInfoResource: BillingInfoResource = {
  getBillingInfo: GET(BILLING_INFO_RESOURCE_BASE_PATH),
  updateUserBillingInfo: PUT(BILLING_INFO_RESOURCE_BASE_PATH),
  createBillingInfo: POST(BILLING_INFO_RESOURCE_BASE_PATH),
  deleteBillingInfo: DELETE(`${BILLING_INFO_RESOURCE_BASE_PATH}/:id`),
};

export default BillingInfoResource;
